module.exports = __webpack_public_path__ + "static/media/center_panel.b09427db.svg";